import { Component, OnInit } from '@angular/core'
import { FileUploadDownloadService } from '../../services/file-upload-download.service'
import { FileUploadResult } from '../../models/http/file-upload-result'
import { AttachmentService } from '../../services/attachment.service'
import { SettingsService } from '../../modules/settings'
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog'
import { NotificationService } from '../../services/notification.service'

const MAIN_TYPE = 'File'

/**
 * covers multiple scenarios:
 * 1a) File entity: create new file:                ownerId: undefined   ownerType: undefined   fileId: undefined
 * 1b) File entity: update existing file:           ownerId: undefined   ownerType: undefined   fileId: set
 * 2a) FileAttachment entity: create new file:      ownerId: set         ownerType: set         fileId: undefined
 * 2b) FileAttachment entity: update existing file: ownerId: set         ownerType: set         fileId: set
 * FileUploadDialogComponent decides depending on these parameters what to do (attach yes/no, update/create)
 */

@Component({
  selector: 'jml-lib-file-upload-dialog',
  templateUrl: './file-upload-dialog.component.html',
  styleUrls: ['./file-upload-dialog.component.scss']
})
export class FileUploadDialogComponent implements OnInit {
  chooseLabel = 'Datei auswählen'
  uploadLabel = 'Hochladen'
  cancelLabel = 'Abbrechen'
  fileId: string

  // entity to attach file to
  ownerId: number
  ownerType: string

  // attachment category for entity
  // currently not used within jmeleon frontend but supported by backend attachmentService.
  attachmentCategory: string

  url: string
  uploadFileName: string
  maxUploadInByte: number

  constructor(
    private fileService: FileUploadDownloadService,
    private attachmentService: AttachmentService,
    private settingService: SettingsService,
    private notificationService: NotificationService,
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef
  ) {}

  ngOnInit() {
    // collect input parameters
    const data = this.config.data
    this.fileId = data['fileId']
    this.ownerId = data['ownerId']
    this.ownerType = data['ownerType']
    this.attachmentCategory = data['attachmentCategory']

    this.setMaxUploadSize(1)
    // this.fileId is set in case of updating an existing file => update; if not set => upload
    this.fileId
      ? (this.url = this.fileService.getUpdateFileUrl())
      : (this.url = this.fileService.getUploadUrl(this.ownerType, this.ownerId))

    this.settingService.getMaxUpload().subscribe((maxUploadInMB) => this.setMaxUploadSize(maxUploadInMB))
  }

  onDlgShow() {
    this.settingService.getMaxUpload().subscribe((maxUploadInMB) => this.setMaxUploadSize(maxUploadInMB))
  }

  setMaxUploadSize(setingInMB) {
    this.maxUploadInByte = setingInMB * 1024 * 1024
  }

  // file upload component events

  onBeforeUpload(event: any) {
    const data: FormData = event.formData
    data.append('fileName', this.uploadFileName)
    data.append('fileType', this.getFileNameAndType(this.uploadFileName).fileType)
    if (this.fileId) {
      data.append('fileId', this.fileId)
    }
  }

  onUpload(event: any) {
    const uploadResult = <FileUploadResult>event.originalEvent.body
    const successMessage: string = `Datei '${uploadResult.fileName}' wurde erfolgreich ${!!this.fileId ? 'aktualisiert.' : 'hochgeladen.'}.`
    this.notificationService.addSuccessNotification(successMessage)
    this.ref.close()
  }

  onError(event: any) {
    this.ref.close()
  }

  onSelect(event: any) {
    this.uploadFileName = event.files[0].name
  }

  private getFileNameAndType(filename: string): { fileName: string; fileType: string | null } {
    const parts = filename.split('.')
    if (parts.length > 1) {
      const fileType = parts.pop()! // Remove and retrieve the last part (extension)
      const fileName = parts.join('.') // Join the rest as the file name
      return { fileName, fileType }
    } else {
      return { fileName: filename, fileType: null } // No extension case
    }
  }
}
